$(document).ready(function () {
	//fix ie7 & ie8 nth-child selector
	$('.lt-ie9 .search-cruises').find('.product:nth-child(2n+2)').addClass('new-line');

	// Modify class for images in "Search Cruises from XXXXXXX" section depending on the number of imgs
	$('.search-cruises').each(function(e) {
		var products = $(this).find('.product');
        	var img_count = products.length;
		switch(img_count){
			case 1:
				products.addClass("one-img");
				break;
			case 2:
				products.addClass("two-img");
				break;
			case 3:
				products.addClass("four-img");
				break;
			case 4:
				products.addClass("four-img");
				break;
		}
    });

	//check if promo is on sale when user's locale promo matches the current page
	$('#locale-notice').on('localeNotice.true', function () {
		isOnSale($(this).attr('data-loc').toUpperCase());
	});

	if ($('.get-special-offers').length) {
		var $form = $('#special-offers-form'),
			specialOffersFormTimer = setInterval(function() {
			if ($form.length) {
				clearInterval(specialOffersFormTimer);
				$form.validate({
					submitHandler: function(form) {
						// check for guestLocale b/c we'll be using localeData later
						guestLocale && guestLocale.isReady(function() {
							specialOffersForm.submit($(form));
						});
					}
				});
			}
		}, 1000);

		// load localized link for Privacy Policy
		loclink.init($form);
	}

	$('.learn-more').each(function(){
		var targetLink = $(this).attr('href');
		$(this).attr('href',$wwwURL + targetLink);
	});

	// load permission console dependencies for cms form
	if ($('.permission-console').length > 0 && typeof dataPrefs == 'undefined') {
		// permissions css
		loadCSS($bookURL + '/css/cc/cc.permissions.css');
		// mustache dependencies
		loadJS('/assetroot/js/global/jquery/plugins/mustache/mustache.js');
		loadJS('/assetroot/js/global/jquery/plugins/mustache/jquery-Mustache.js');
		// permissions js
		loadJS($bookURL + '/js/cc/cc.permissions.js');
	}
	
	$.ajax({
		url: $bookURL+ '/captaincircle/createToken.do',
		type: 'GET',
		dataType: 'json',
		xhrFields: {
			withCredentials: true
		},
	})
	.then(function (results) {
		if(results.status) {
			$('#csrf').val(results.data);
		}
	});
 	
});

/**
 * [isOnSale] - Determine if the current time is before/during/after the sale
 * 				1. before sale: display pricing entered by webops
 * 				2. during the sale: run dynamic pricing as needed
 * 				3. after sale: don't display pricing
 */
function isOnSale(loc) {
	//run dynamic pricing when sale is in effect
	var currentTime = new Date().getTime(),
		$products = $('a[data-pricing="true"]'),
		options = {
			country: loc,
			end: dateSaleEnd,
			start: dateSaleBegin
		};

	// load dynamic pricing with page locale & start / end
	loadDynamicPricing.init($products, options);
		
	if (typeof dateSaleBegin != 'undefined' && typeof dateSaleEnd != 'undefined') {
		// display time remaining in #offer-ends
		if($('#offer-ends').length > 0) {
			var dateSaleEndTimestamp = dateSaleEnd.getTime();
			countDown(dateSaleEndTimestamp, $('#offer-ends'));
		}
	}
}

function countDown(endTimestamp, $offersEnds) {
	var currentDate = new Date(),
	    currentTimestamp = currentDate.getTime();

	// make sure current timestamp is not past sale end timestamp
	if (endTimestamp > currentTimestamp) {
		var timeRemaining = endTimestamp - currentTimestamp,
		    endText = '',
		    daysRemaining = 0,
		    hoursRemaining = 0,
		    minutesRemaining = 0,
		    day = 86400000,
		    hour = 3600000,
		    minute = 60000;

		daysRemaining = Math.floor(timeRemaining/day);

		if (daysRemaining > 0) {
			// if more than one day, include an s at the end of Days
			endText = 'in <span class="no-wrap">' + daysRemaining + ((daysRemaining==1) ? " Day":" Days") + '</span>';
		} else {
			hoursRemaining = Math.floor(timeRemaining/hour);
			timeRemaining=timeRemaining%hour;
			minutesRemaining=Math.floor(timeRemaining/minute);
			endText = '<span class="no-wrap">' + hoursRemaining + ' ' + ((hoursRemaining==1) ? 'hr':'hrs') + '</span>';
			endText += ' and ';
			endText += '<span class="no-wrap">' + minutesRemaining + ' ' + ((minutesRemaining==1) ? 'min':'mins') + '</span>';

			var countDownTimer = setInterval(function () {
				countDown(endTimestamp, $offersEnds);
			}, 60000);
		}

		// insert ends in text into lto-promo
		$offersEnds.find('.offer-ends-time').html(endText);

		// show lto-promo bar if not visible
		if ($offersEnds.hasClass('hidden')) {
			$offersEnds.removeClass('hidden')
		}
	} else {
		if (typeof countDownTimer !== 'undefined') {
			clearInterval(countDownTimer);
		}
	}
}

var specialOffersForm = {
	submit: function($form) {
		var $error = $('.special-offers-error');

		// store values for data massage
		this.values = $form.serializeArray();
		// loading start
		this.toggleLoading('start');
		!$error.hasClass('hidden') && $error.addClass('hidden');
		// get token, post leadgen
		$.when(this.getToken()).then(
			this.handleSuccess,
			this.handleError
		);
	},
	handleSuccess: function(response) {
		var self = specialOffersForm,
			headers = self.getRequestHeader(response.db_token);

		$.ajax({
			type: 'POST',
			url: $bookURL + '/aval/v1.0/contacts/leadgen',
			contentType: 'application/json; charset=UTF-8',
			data: JSON.stringify(self.getPayload()),
			headers: headers
		}).done(function(response) {
			var isSuccessful = response.Contact.StatusResponse.Status === 'SUCCESS';
			if (isSuccessful) {
				// loading end
				self.toggleLoading('end');
				// update content markup
				$('.get-special-offers').html(self.confirmation());
			}
			else {
				self.handleError();
			}
		})
		.fail(self.handleError);
	},
	handleError: function(error) {
		var self = specialOffersForm;
		$('.special-offers-error').removeClass('hidden');
		self.toggleLoading('end');
	},
	toggleLoading: function(status) {
		var $submit = $('#special-offers-btn'),
			$loading = $('.special-offers-loading');

		switch(status) {
			case 'start':
				$submit.addClass('hidden');
				$loading.removeClass('hidden');
				break;
			case 'end':
				$submit.removeClass('hidden');
				$loading.addClass('hidden');
				break;
		}
	},
	getInputValue: function(id) {
		return this.values.find(function(el) {
			return el.name === id;
		}).value;
	},
	getToken: function() {
		var env = sub_domain_substring[0];
		$bookURL = env === 'preprod' ? 'https://stagewww.princess.com/' : $bookURL;
		var token = env !== 'dev'
			? $.ajax({
				type: 'GET',
				url: $bookURL + '/db-services-pricing/p1.0/dbtoken'
			})
			: '';
		return token;
	},
	getRequestHeader: function(token) {
		return {
			'ProductCompany': 'PC',
			'BookingCompany': 'PC',
			'AuthToken': token || '',
			'AppId': JSON.stringify({
				'IP': localeData.ipAddress,
				'id': 'CC'
			})
		};
	},
	getPayload: function() {
		return {
			'Contact': {
				'CruiseCompany': {
					'BookingCompanyCode': 'PC',
					'ProductCompanyCode': 'PC'
				},
				'Name': {
					'LastName': this.getInputValue('lastName'),
					'FirstName': this.getInputValue('firstName')
				},
				'Email': {
					'Email': this.getInputValue('email')
				},
				'FormCode': 'SPCLOFFER',
				'QuestionAnswers': [
					{
						'Question': '194',
						'Answer': [this.getInputValue('q194')]
					}
				]
			}
		};
	},
	confirmation: function() {
		return (
			'<div class="special-offers-confirmation col-xs-12">' +
				'<h3 class="gotham-xn-medium font-size-p8">Congratulations!</h3>' +
				'<p class="">You are now signed up to receive special offers!</p>' +
				'<p>Want to see what kind of deals we have going on now?</p>' +
				'<a class="gotham-bold font-size-p2" href="' + $wwwURL + '/topcruisedeals.jsp" target="_blank">View our current Top Cruise Deals!</a>' +
				'<h4 class="gotham-xn-medium font-size-p3">Continue below to register with Princess Cruises</h4>' +
				'<p>Take a moment to register with Princess and stay up to date on everything Princess Cruises has to offer.</p>' +
				'<ul>' +
					'<li>Access to the best fares</li>' +
					'<li>Download or order the latest brochures</li>' +
					'<li>View your Circle Savings Account</li>' +
					'<li>Book online</li>' +
				'</ul>' +
				'<form id="cont-to-reg" method="post" action="' + $bookURL + '/captaincircle/showRegistration.page">' +
					'<div class="align-center">' +
						'<button id="continue-to-reg" class="button green-btn font-size-p5 continue-btn">Continue</button>' +
					'</div>' +
					'<input type="hidden" name="contactInfo.firstName" id="firstName" value="' + this.getInputValue('firstName') + '" />' +
					'<input type="hidden" name="contactInfo.lastName" id="lastName" value="' + this.getInputValue('lastName') + '" />' +
					'<input type="hidden" name="contactInfo.address.email" id="email" value="' + this.getInputValue('email') + '" />' +
					'<input type="hidden" name="selAnswerQ194" id="q194" value="' + this.getInputValue('q194') + '" />' +
				'</form>' +
			'</div>'
		)
	}
}